import { createDebug } from '../debug';

export default createDebug('store');



// WEBPACK FOOTER //
// ./src/store/debug.js